import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, MenuItem } from '@mui/material'

// STORE
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'

// API
import { DepartMentApi, createDepartment } from '../../../../../api/department/department.api'

// COMPONENT
import { swalError, swalSuccess } from '../../../../../component/notification/swal'
import { notificationSwal } from '../../../../../utils/notification.swal'
import InputTextField from '../../../../../component/input/inputTextField'
import FilterSelect from '../../../../../component/select/filterSelect'
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom'

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    idDepartmentRef: number;
}

const AddDepartment = (props: Props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation()

    const [departmentDetail, setDepartmentDetail] = useState<createDepartment>({
        departmentName: "",
        departmentStatus: t("STATUS.ACTIVE"),
        departmentAddress: "",
        departmentEmail: "",
        departmentFax: "",
        departmentTel: "",
        idDepartmentRef: props.idDepartmentRef
    })

    const handleChangeStatus = (event: React.ChangeEvent<HTMLSelectElement>) => setDepartmentDetail({ ...departmentDetail, departmentStatus: event.target.value })
    const handleCreateDepartments = async (event: React.FormEvent) => {
        // console.log(departmentDetail,'departmentDetail')
        dispatch(setLoading())
        event.preventDefault();
        await DepartMentApi.createDepartments(departmentDetail)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(notificationSwal.success)
                } else {
                    dispatch(unsetLoading())
                    swalError(notificationSwal.error)
                }
            })
            .catch(error => {
                console.log(error)
                dispatch(unsetLoading())
            })
            .finally(() => {
                props.fetchData();
                props.toggleModal();
            })
    }

    return (
        <div>
            <form onSubmit={handleCreateDepartments} className='w-full'>
                <Box className='w-full mt-8 flex flex-col gap-5'>
                    <span className='grid grid-cols-6 gap-[10px]'>
                        <div className='col-span-6 md:col-span-6'>
                            <InputTextField
                                required
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setDepartmentDetail({ ...departmentDetail, departmentName: e.target.value })}
                                value={departmentDetail.departmentName}
                                heading='ชื่อหน่วยงาน'
                            />
                        </div>
                    </span>
                    <span className='grid grid-cols-6 gap-[10px]'>
                        <div className='col-span-6 md:col-span-6'>
                            <InputTextField
                                required
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setDepartmentDetail({ ...departmentDetail, departmentAddress: e.target.value })}
                                value={departmentDetail.departmentAddress}
                                heading='ที่อยู่หน่วยงาน'
                            />
                        </div>
                    </span>
                    <span className='grid grid-cols-6 gap-[10px]'>
                        <div className='col-span-6 md:col-span-6'>
                            <InputTextField
                                // required
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setDepartmentDetail({ ...departmentDetail, departmentTel: e.target.value })}
                                value={departmentDetail.departmentTel}
                                heading='เบอร์โทรศัพท์หน่วยงาน'
                            />
                        </div>
                    </span>
                    <span className='grid grid-cols-6 gap-[10px]'>
                        <div className='col-span-6 md:col-span-6'>
                            <InputTextField
                                // required
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setDepartmentDetail({ ...departmentDetail, departmentFax: e.target.value })}
                                value={departmentDetail.departmentFax}
                                heading='เบอร์โทรสาร'
                            />
                        </div>
                    </span>
                    <span className='grid grid-cols-6 gap-[10px]'>
                        <div className='col-span-6 md:col-span-6'>
                            <InputTextField
                                type='email'
                                // required
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setDepartmentDetail({ ...departmentDetail, departmentEmail: e.target.value })}
                                value={departmentDetail.departmentEmail}
                                heading='อีเมล'
                            />
                        </div>
                    </span>
                    <span>
                        <FilterSelect
                            required
                            heading='สถานะ'
                            label={t('STATUS.LABEL')}
                            selectId="select-fiscal-year"
                            value={departmentDetail.departmentStatus}
                            labelId="label-fiscal-year"
                            onchange={handleChangeStatus}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <li className='text-primary'>{t("STATUS.ACTIVE")}</li>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <li className='text-danger'>{t("STATUS.INACTIVE")}</li>
                                </MenuItem>
                            ]}
                        />
                    </span>
                    <span className='mt-3 flex items-center justify-center'>
                        <ButtonContained
                            type='submit'
                            sx={{ maxWidth: 90 }}
                        >
                            {t("BUTTON.SAVE")}
                        </ButtonContained>
                    </span>
                </Box>
            </form>
        </div>
    )
}

export default AddDepartment